<template>
  <el-scrollbar class="components-attr-edit">
    <p class="page-title fontBold">页面属性</p>
    <div class="attr-item-edit-wrapper">
      <p class="attr-item-title">页面名：</p>
      <div class="attr-item-edit-input no-top">
        <el-form @submit.native.prevent="() => {}">
          <el-form-item>
            <el-input v-model="activePage.name" placeholder="请输入页面名"></el-input>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="attr-item-edit-wrapper">
      <p class="attr-item-title">背景颜色：</p>
      <div class="attr-item-edit-input no-top">
        <el-color-picker size="mini" :show-alpha="true"
                         v-model="activePage.commonStyle.backgroundColor"></el-color-picker>
      </div>
    </div>
    <div class="attr-item-edit-wrapper">
      <p class="attr-item-title">背景图片：</p>
      <div class="attr-item-edit-input">
        <imageSelect :url.sync="activePage.commonStyle.backgroundImage" />
      </div>
    </div>
    <div class="attr-item-edit-wrapper">
      <p class="attr-item-title">背景图片样式：</p>
      <div class="attr-item-edit-input" style="display:flex;flex-direction: column;justify-content: flex-start;align-items: flex-start;">
        <el-radio style="margin-bottom:5px;" v-model="activePage.backgroundImageStyle" label="1">高度铺满，宽度自适应</el-radio>
        <el-radio v-model="activePage.backgroundImageStyle" label="2">宽高均铺满</el-radio>
      </div>
    </div>
  </el-scrollbar>
</template>

<script>
	import {mapState, mapGetters} from 'vuex'
	import imageSelect from '@client/components/image-select'
	export default {
		components: {
			imageSelect
		},
		computed: {
			...mapState({
				projectData: state => state.editor.projectData,
				activePageUUID: state => state.editor.activePageUUID,
				activeElementUUID: state => state.editor.activeElementUUID
			}),
			...mapGetters([
				'currentPageIndex',
				'activeElementIndex',
				'activeElement',
        'activePage'
			])
		},
	}
</script>

<style lang="scss" scoped>
  ::v-deep .el-input__inner{
    background: #1f2353;
  }
  .components-attr-edit {
    height: 100%;
  }

  .components-attr-animate-edit {
    position: relative;
  }

  .attr-title {
    font-weight: bold;
  }
  .attr-item-edit-wrapper {
    padding-left: 18px;
    display: flex;
    width: 100%;
    text-align: center;
    padding-bottom: 10px;
    .attr-item-title {
      text-align: left;
      min-width: 60px;
      font-size: 12px;
    }
    .attr-item-edit-input {
      &.col-2 {
        width: 90px;
        margin-left: 10px;
      }
      &.col-1 {
        width: 250px;
      }
      &.col-3 {
        width: 60px;
        margin-left: 10px;
      }
      &.col-4 {
        width: 50px;
        margin-left: 10px;
      }
      .attr-item-edit-input-des {
        text-align: center;
        line-height: 1;
        margin-top: 2px;
        font-size: 12px;
        color: $gray;
      }
    }
  }
</style>
